/**
 * Email format check used on the register flow (PersonalDetails) and login email forms.
 * Keep in sync with any server-side rules for learner/instructor email.
 */
export const EMAIL_FORMAT_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailFormat(email) {
    if (email == null || typeof email !== 'string') return false;
    return EMAIL_FORMAT_REGEX.test(email.trim());
}
